import React, { FC } from 'react';

const Description: FC = () => <span />;

export default Description;
